export default __webpack_public_path__ + "static/media/41k.03f94321.md";